import * as React from "react";
import Header from "./Header";
import { appContext } from "../../hooks/provider";
import Footer from "./Footer";
import { LegalNotice } from "../common";
import Seo, { ogTypes } from "./Seo";
import { LaunchButton } from "@multiagentbook/ui";

type Props = {
  title: string;
  link: string;
  description?: string;
  children?: React.ReactNode;
  showHeader?: boolean;
  restricted?: boolean;
  meta?: any;
  ogImage?: ogTypes;
};

const shortcodes = {
  LaunchButton,
};

const Layout = ({
  meta,
  title,
  link,
  children,
  description,
  showHeader = true,
  restricted = false,
  ogImage = "default",
}: Props) => {
  const LayoutView = ({ darkMode, user }: { darkMode: string; user: any }) => {
    React.useEffect(() => {
      const htmlElement = document.getElementsByTagName("html")[0];

      // Remove existing dark/light mode classes
      htmlElement.classList.remove("dark", "light", "bg-primary", "h-full");

      // Add the appropriate classes for current mode
      if (darkMode === "dark") {
        htmlElement.classList.add("dark", "bg-primary", "h-full");
      } else {
        htmlElement.classList.add("light", "bg-primary", "h-full");
      }
    }, [darkMode]);

    return (
      <div className={`  h-full flex flex-col`}>
        <div className=" pointer-events-none opacity-0 h-0">
          Multi-agent systems are the next frontier for building generative AI
          applications - Andrew Ng, 2024. However, many questions arise - how do
          we design these systems? When should we use them? How can we
          effectively integrate them into end-user applications? In Designing
          Multi-Agent Systems, author Victor Dibia draws on his experience
          building agent frameworks and developer tools - including AutoGen and
          AutoGen Studio - to provide a comprehensive hands-on guide to
          architecting, implementing, evaluating, and deploying multi-agent
          systems.
        </div>
        <Seo title={title} description={description} ogImage={ogImage} />
        <div className="flex-1 text-primary">
          <title>{meta?.title + " | " + title}</title>
          {showHeader && (
            <Header
              user={user}
              links={[
                { href: "/", title: "Home" },
                // { href: "/dashboard", title: "Dashboard" }
              ]}
              link={link}
              meta={meta}
            />
          )}

          {children}
        </div>
        <LegalNotice />
        <Footer />
      </div>
    );
  };

  return (
    <appContext.Consumer>
      {(context: any) => {
        if (restricted) {
          return (
            <div className="h-screen bg-yellow-100 ">
              {context.user && (
                <LayoutView darkMode={context.darkMode} user={context.user} />
              )}
              {!context.user && (
                <div className="flex items-center justify-center h-full">
                  <div className="text-center">
                    <h2 className="text-xl font-semibold mb-4">
                      Access Restricted
                    </h2>
                    <p className="text-secondary mb-4">
                      Please sign in to view this content.
                    </p>
                    <a
                      href="/"
                      className="bg-accent text-invert px-4 py-2 rounded-lg"
                    >
                      Go to Home
                    </a>
                  </div>
                </div>
              )}
            </div>
          );
        } else {
          return <LayoutView darkMode={context.darkMode} user={context.user} />;
        }
      }}
    </appContext.Consumer>
  );
};

export default Layout;
